import { Box, Typography } from "@mui/material";
import PulseLoader from "react-spinners/PulseLoader";

export const LoadingOverlay = ({ text }) => (
  <Box
    sx={{
      position: "fixed", // Set to fixed position
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "20px",
      backgroundColor: !text ? "#000000" : "rgba(0, 0, 0, 0.4)", // semi-transparent background
      zIndex: 999, // Ensure the overlay is on top of other elements
    }}
  >
    {!text && (
      <img src="/bidd_logo.svg" alt="bidd-logo" width="160" height="40" />
    )}
    <PulseLoader color={"#78CA72"} />
    <Typography
      sx={{
        color: "#2DFF54",
        fontFamily: "Lexend",
        fontSize: "28px",
        fontWeight: "600",
      }}
    >
      {text}
    </Typography>
    {/* You can replace this with a spinner or any other loading indicator */}

    <img
      style={{ display: "none" }}
      src="/images/blodrur-mynd.svg"
      alt="blodrur-mynd"
      width="407"
      height="407"
    />
  </Box>
);
